// import React, { useState } from "react";
// /* ── Life stage → approx age range mapping (adjust to your clinic's real criteria) ── */
// const LIFE_STAGE_AGE_RANGES = {
//   "Adolescent": { min: 10, max: 19 },
//   "Reproductive Age": { min: 20, max: 45 },
//   "Pregnancy": { min: 15, max: 45 },
//   "Postpartum": { min: 15, max: 45 },
//   "Menopause": { min: 40, max: 60 },
// };

// const calculateAge = (dobStr) => {
//   const dob = new Date(dobStr);
//   const today = new Date();
//   let age = today.getFullYear() - dob.getFullYear();
//   const m = today.getMonth() - dob.getMonth();
//   if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
//   return age;
// };

// const checkEligibility = (age, lifeStages = []) => {
//   return lifeStages.some((stage) => {
//     const range = LIFE_STAGE_AGE_RANGES[stage.name];
//     if (!range) return false;
//     return age >= range.min && age <= range.max;
//   });
// };

// const STEPS = {
//   DETAILS: "details",
//   CONSENT: "consent",
//   FORM: "form",
//   NOT_ELIGIBLE: "not_eligible",
//   OTP: "otp",
//   SUCCESS: "success",
// };

// const CORRECT_OTP = "123456";

// const ProgramEnrollment = ({ program, isOpen, onClose, onComplete }) => {
//   const [step, setStep] = useState(STEPS.DETAILS);
//   const [consentChecked, setConsentChecked] = useState(false);
//   const [formData, setFormData] = useState({ name: "", dob: "", phone: "" });
//   const [formErrors, setFormErrors] = useState({});
//   const [otp, setOtp] = useState("");
//   const [otpError, setOtpError] = useState("");

//   if (!isOpen || !program) return null;

//   const {
//     programName,
//     description,
//     durationValue,
//     durationUnit,
//     price,
//     consultationModes = [],
//     conditionFocuses = [],
//     lifeStages = [],
//   } = program;

//   const mode = consultationModes.map((c) => c.name).filter(Boolean).join(", ") || "Hybrid";
//   const durationLabel = durationValue ? `${durationValue} ${durationUnit ?? "days"}` : null;
//   const highlights = [
//     ...conditionFocuses.map((c) => c.name),
//     ...lifeStages.map((l) => l.name),
//   ].filter(Boolean);

//   const resetAndClose = () => {
//     setStep(STEPS.DETAILS);
//     setConsentChecked(false);
//     setFormData({ name: "", dob: "", phone: "" });
//     setFormErrors({});
//     setOtp("");
//     setOtpError("");
//     onClose();
//   };

//   const handleFormChange = (field) => (e) => {
//     setFormData((prev) => ({ ...prev, [field]: e.target.value }));
//     setFormErrors((prev) => ({ ...prev, [field]: null }));
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.name.trim()) errors.name = "Full name is required";
//     if (!formData.dob) errors.dob = "Date of birth is required";
//     if (!formData.phone.trim()) {
//       errors.phone = "Mobile number is required";
//     } else if (!/^\d{10}$/.test(formData.phone.trim())) {
//       errors.phone = "Enter a valid 10-digit number";
//     }
//     return errors;
//   };

//   const handleFormSubmit = () => {
//     const errors = validateForm();
//     if (Object.keys(errors).length > 0) {
//       setFormErrors(errors);
//       return;
//     }
//     const age = calculateAge(formData.dob);
//     const eligible = checkEligibility(age, lifeStages);
//     setStep(eligible ? STEPS.OTP : STEPS.NOT_ELIGIBLE);
//   };

//   const handleOtpSubmit = () => {
//     if (otp.trim() === CORRECT_OTP) {
//       setOtpError("");
//       setStep(STEPS.SUCCESS);
//     } else {
//       setOtpError("Incorrect OTP. Please try again.");
//     }
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.45)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 1000,
//         padding: 16,
//       }}
//       onClick={resetAndClose}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 440,
//           maxHeight: "90vh",
//           overflowY: "auto",
//           padding: "24px 24px 20px",
//           position: "relative",
//         }}
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* Close button */}
//         {step !== STEPS.SUCCESS && (
//           <button
//             onClick={resetAndClose}
//             style={{
//               position: "absolute",
//               top: 16,
//               right: 16,
//               background: "none",
//               border: "none",
//               cursor: "pointer",
//               fontSize: 20,
//               color: "#999",
//               lineHeight: 1,
//             }}
//           >
//             ×
//           </button>
//         )}

//         {/* ── STEP 1: PROGRAM DETAILS ── */}
//         {step === STEPS.DETAILS && (
//           <>
//             <span style={{ fontSize: 11, fontWeight: 600, color: "#e91e8c", letterSpacing: 0.5 }}>
//               STEP 1 OF 4 — PROGRAM DETAILS
//             </span>
//             <h2 style={{ fontSize: 19, fontWeight: 700, color: "#1a1a2e", margin: "8px 0 6px" }}>
//               {programName}
//             </h2>
//             <p style={{ fontSize: 13, color: "#666", lineHeight: 1.5, margin: "0 0 18px" }}>
//               {description}
//             </p>

//             <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
//               {durationLabel && (
//                 <div style={{ flex: 1, background: "#f8f8fa", borderRadius: 12, padding: "10px 12px" }}>
//                   <div style={{ fontSize: 10, color: "#aaa", fontWeight: 500, marginBottom: 3 }}>Duration</div>
//                   <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a2e" }}>{durationLabel}</div>
//                 </div>
//               )}
//               {price != null && (
//                 <div style={{ flex: 1, background: "#f8f8fa", borderRadius: 12, padding: "10px 12px" }}>
//                   <div style={{ fontSize: 10, color: "#aaa", fontWeight: 500, marginBottom: 3 }}>Price</div>
//                   <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a2e" }}>
//                     ₹{price.toLocaleString("en-IN")}
//                   </div>
//                 </div>
//               )}
//               <div style={{ flex: 1, background: "#f8f8fa", borderRadius: 12, padding: "10px 12px" }}>
//                 <div style={{ fontSize: 10, color: "#aaa", fontWeight: 500, marginBottom: 3 }}>Mode</div>
//                 <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a2e" }}>{mode}</div>
//               </div>
//             </div>

//             {highlights.length > 0 && (
//               <div style={{ marginBottom: 22 }}>
//                 <div style={{ fontSize: 11, fontWeight: 700, color: "#555", marginBottom: 8 }}>
//                   This program covers
//                 </div>
//                 <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
//                   {highlights.map((h) => (
//                     <span
//                       key={h}
//                       style={{
//                         fontSize: 11,
//                         color: "#e91e8c",
//                         background: "#fce4ec",
//                         borderRadius: 20,
//                         padding: "4px 10px",
//                         fontWeight: 500,
//                       }}
//                     >
//                       {h}
//                     </span>
//                   ))}
//                 </div>
//               </div>
//             )}

//             <div style={{ display: "flex", gap: 10 }}>
//               <button className="btn-transparent" style={{ flex: 1 }} onClick={resetAndClose}>
//                 Cancel
//               </button>
//               <button className="btn-secondary" style={{ flex: 1 }} onClick={() => setStep(STEPS.CONSENT)}>
//                 Continue
//               </button>
//             </div>
//           </>
//         )}

//         {/* ── STEP 2: CONSENT ── */}
//         {step === STEPS.CONSENT && (
//           <>
//             <span style={{ fontSize: 11, fontWeight: 600, color: "#e91e8c", letterSpacing: 0.5 }}>
//               STEP 2 OF 4 — CONSENT
//             </span>
//             <h2 style={{ fontSize: 19, fontWeight: 700, color: "#1a1a2e", margin: "8px 0 14px" }}>
//               Before we proceed
//             </h2>

//             <div
//               style={{
//                 background: "#f8f8fa",
//                 borderRadius: 12,
//                 padding: "14px 16px",
//                 fontSize: 12.5,
//                 color: "#555",
//                 lineHeight: 1.6,
//                 marginBottom: 18,
//                 maxHeight: 200,
//                 overflowY: "auto",
//               }}
//             >
//               By continuing, you consent to sharing your personal and health-related
//               information (name, date of birth, and contact number) with our care team
//               for the purpose of enrolling you in the <strong>{programName}</strong>.
//               This information will be used to verify your eligibility, contact you
//               regarding your enrollment, and coordinate your care. Your data will be
//               handled in accordance with our clinic's privacy policy and will not be
//               shared with third parties without your permission.
//             </div>

//             <label
//               style={{
//                 display: "flex",
//                 alignItems: "flex-start",
//                 gap: 10,
//                 marginBottom: 22,
//                 cursor: "pointer",
//                 fontSize: 13,
//                 color: "#333",
//               }}
//             >
//               <input
//                 type="checkbox"
//                 checked={consentChecked}
//                 onChange={(e) => setConsentChecked(e.target.checked)}
//                 style={{ marginTop: 2 }}
//               />
//               I have read and agree to share my information for this enrollment.
//             </label>

//             <div style={{ display: "flex", gap: 10 }}>
//               <button className="btn-transparent" style={{ flex: 1 }} onClick={() => setStep(STEPS.DETAILS)}>
//                 Back
//               </button>
//               <button
//                 className="btn-secondary"
//                 style={{ flex: 1, opacity: consentChecked ? 1 : 0.5, pointerEvents: consentChecked ? "auto" : "none" }}
//                 onClick={() => setStep(STEPS.FORM)}
//               >
//                 Continue
//               </button>
//             </div>
//           </>
//         )}

//         {/* ── STEP 3: FORM ── */}
//         {step === STEPS.FORM && (
//           <>
//             <span style={{ fontSize: 11, fontWeight: 600, color: "#e91e8c", letterSpacing: 0.5 }}>
//               STEP 3 OF 4 — YOUR DETAILS
//             </span>
//             <h2 style={{ fontSize: 19, fontWeight: 700, color: "#1a1a2e", margin: "8px 0 18px" }}>
//               Tell us about you
//             </h2>

//             <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 22 }}>
//               <div>
//                 <label style={{ fontSize: 12, fontWeight: 600, color: "#444", display: "block", marginBottom: 5 }}>
//                   Full Name
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.name}
//                   onChange={handleFormChange("name")}
//                   placeholder="Enter your full name"
//                   style={{
//                     width: "100%",
//                     padding: "10px 12px",
//                     borderRadius: 10,
//                     border: `1px solid ${formErrors.name ? "#e53935" : "#e0e0e0"}`,
//                     fontSize: 13,
//                     boxSizing: "border-box",
//                   }}
//                 />
//                 {formErrors.name && (
//                   <span style={{ fontSize: 11, color: "#e53935" }}>{formErrors.name}</span>
//                 )}
//               </div>

//               <div>
//                 <label style={{ fontSize: 12, fontWeight: 600, color: "#444", display: "block", marginBottom: 5 }}>
//                   Date of Birth
//                 </label>
//                 <input
//                   type="date"
//                   value={formData.dob}
//                   onChange={handleFormChange("dob")}
//                   max={new Date().toISOString().split("T")[0]}
//                   style={{
//                     width: "100%",
//                     padding: "10px 12px",
//                     borderRadius: 10,
//                     border: `1px solid ${formErrors.dob ? "#e53935" : "#e0e0e0"}`,
//                     fontSize: 13,
//                     boxSizing: "border-box",
//                   }}
//                 />
//                 {formErrors.dob && (
//                   <span style={{ fontSize: 11, color: "#e53935" }}>{formErrors.dob}</span>
//                 )}
//               </div>

//               <div>
//                 <label style={{ fontSize: 12, fontWeight: 600, color: "#444", display: "block", marginBottom: 5 }}>
//                   Mobile Number
//                 </label>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <span
//                     style={{
//                       padding: "10px 12px",
//                       borderRadius: 10,
//                       border: "1px solid #e0e0e0",
//                       fontSize: 13,
//                       color: "#666",
//                       background: "#f8f8fa",
//                     }}
//                   >
//                     +91
//                   </span>
//                   <input
//                     type="tel"
//                     value={formData.phone}
//                     onChange={handleFormChange("phone")}
//                     placeholder="Enter your number"
//                     maxLength={10}
//                     style={{
//                       flex: 1,
//                       padding: "10px 12px",
//                       borderRadius: 10,
//                       border: `1px solid ${formErrors.phone ? "#e53935" : "#e0e0e0"}`,
//                       fontSize: 13,
//                       boxSizing: "border-box",
//                     }}
//                   />
//                 </div>
//                 {formErrors.phone && (
//                   <span style={{ fontSize: 11, color: "#e53935" }}>{formErrors.phone}</span>
//                 )}
//               </div>
//             </div>

//             <div style={{ display: "flex", gap: 10 }}>
//               <button className="btn-transparent" style={{ flex: 1 }} onClick={() => setStep(STEPS.CONSENT)}>
//                 Back
//               </button>
//               <button className="btn-secondary" style={{ flex: 1 }} onClick={handleFormSubmit}>
//                 Continue
//               </button>
//             </div>
//           </>
//         )}

//         {/* ── NOT ELIGIBLE ── */}
//         {step === STEPS.NOT_ELIGIBLE && (
//           <>
//             <div style={{ textAlign: "center", padding: "20px 0" }}>
//               <div
//                 style={{
//                   width: 64,
//                   height: 64,
//                   borderRadius: "50%",
//                   background: "#fdecea",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   margin: "0 auto 18px",
//                 }}
//               >
//                 <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#e53935" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                   <circle cx="12" cy="12" r="10" />
//                   <line x1="15" y1="9" x2="9" y2="15" />
//                   <line x1="9" y1="9" x2="15" y2="15" />
//                 </svg>
//               </div>
//               <h2 style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", margin: "0 0 8px" }}>
//                 Not Eligible for This Program
//               </h2>
//               <p style={{ fontSize: 13, color: "#777", lineHeight: 1.5, margin: "0 0 22px" }}>
//                 Based on the details you've shared, this program may not be the right
//                 fit for you right now. Our care team can help you find a more suitable
//                 option.
//               </p>
//             </div>
//             <div style={{ display: "flex", gap: 10 }}>
//               <button className="btn-transparent" style={{ flex: 1 }} onClick={() => setStep(STEPS.FORM)}>
//                 Back
//               </button>
//               <button className="btn-secondary" style={{ flex: 1 }} onClick={resetAndClose}>
//                 Close
//               </button>
//             </div>
//           </>
//         )}

//         {/* ── STEP 4: OTP ── */}
//         {step === STEPS.OTP && (
//           <>
//             <span style={{ fontSize: 11, fontWeight: 600, color: "#e91e8c", letterSpacing: 0.5 }}>
//               STEP 4 OF 4 — VERIFY MOBILE NUMBER
//             </span>
//             <h2 style={{ fontSize: 19, fontWeight: 700, color: "#1a1a2e", margin: "8px 0 6px" }}>
//               Enter OTP
//             </h2>
//             <p style={{ fontSize: 13, color: "#666", margin: "0 0 20px" }}>
//               We've sent a 6-digit code to +91 {formData.phone}
//             </p>

//             <input
//               type="text"
//               value={otp}
//               onChange={(e) => {
//                 setOtp(e.target.value.replace(/\D/g, "").slice(0, 6));
//                 setOtpError("");
//               }}
//               placeholder="Enter 6-digit OTP"
//               maxLength={6}
//               style={{
//                 width: "100%",
//                 padding: "12px 14px",
//                 borderRadius: 10,
//                 border: `1px solid ${otpError ? "#e53935" : "#e0e0e0"}`,
//                 fontSize: 18,
//                 letterSpacing: 6,
//                 textAlign: "center",
//                 boxSizing: "border-box",
//                 marginBottom: 8,
//               }}
//             />
//             {otpError && (
//               <div style={{ fontSize: 12, color: "#e53935", marginBottom: 12 }}>{otpError}</div>
//             )}

//             <div style={{ display: "flex", gap: 10, marginTop: 18 }}>
//               <button className="btn-transparent" style={{ flex: 1 }} onClick={() => setStep(STEPS.FORM)}>
//                 Back
//               </button>
//               <button
//                 className="btn-secondary"
//                 style={{ flex: 1, opacity: otp.length === 6 ? 1 : 0.5, pointerEvents: otp.length === 6 ? "auto" : "none" }}
//                 onClick={handleOtpSubmit}
//               >
//                 Verify
//               </button>
//             </div>
//           </>
//         )}

//         {/* ── SUCCESS ── */}
//         {step === STEPS.SUCCESS && (
//           <div style={{ textAlign: "center", padding: "20px 0" }}>
//             <div
//               style={{
//                 width: 72,
//                 height: 72,
//                 borderRadius: "50%",
//                 background: "#e8f5e9",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 margin: "0 auto 18px",
//               }}
//             >
//               <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#43a047" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                 <polyline points="20 6 9 17 4 12" />
//               </svg>
//             </div>
//             <h2 style={{ fontSize: 20, fontWeight: 700, color: "#1a1a2e", margin: "0 0 8px" }}>
//               Enrollment Successful!
//             </h2>
//             <p style={{ fontSize: 13, color: "#777", lineHeight: 1.5, margin: "0 0 24px" }}>
//               Thank you for enrolling in the <strong>{programName}</strong>.
//               Our care team will contact you within 24 hours on your registered number.
//             </p>
//             <button
//               className="btn-secondary"
//               style={{ width: "100%" }}
//               onClick={() => {
//                 onComplete?.({ program, formData });
//                 resetAndClose();
//               }}
//             >
//               Done
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProgramEnrollment;

import React, { useState, useRef, useEffect, useCallback } from "react";
import { useAuth } from "../../hooks/useAuth";
import { sendQuickOtp, quickRegister, verifyOtp } from "../../api/auth.api";
import { isMobileVerified, storePatientSession } from "../../utils/storage/authStorage";
import { Notification } from "../../utils";

/* ── Life stage → approx age range mapping (adjust to your clinic's real criteria) ── */
const LIFE_STAGE_AGE_RANGES = {
    "Adolescent": { min: 10, max: 19 },
    "Reproductive Age": { min: 20, max: 44 },
    "Pregnancy": { min: 18, max: 50 },
    "Postpartum": { min: 18, max: 50 },
    "Menopause": { min: 40, max: 60 },
};

const calculateAge = (dobStr) => {
    const dob = new Date(dobStr);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
    return age;
};

const checkEligibility = (age, lifeStages = []) => {
    return lifeStages.some((stage) => {
        const range = LIFE_STAGE_AGE_RANGES[stage.name];
        if (!range) return false;
        return age >= range.min && age <= range.max;
    });
};

const STEPS = {
    DETAILS: "details",
    CONSENT: "consent",
    FORM: "form",
    NOT_ELIGIBLE: "not_eligible",
    OTP: "otp",
    SUCCESS: "success",
};

const OTP_LENGTH = 6;
const getIneligibilityReason = (age, lifeStages = []) => {
    const ranges = lifeStages
        .map((stage) => LIFE_STAGE_AGE_RANGES[stage.name])
        .filter(Boolean);

    if (ranges.length === 0) {
        return {
            type: "unknown",
            message: "We couldn't determine eligibility for this program based on the details provided.",
        };
    }

    const minAllowed = Math.min(...ranges.map((r) => r.min));
    const maxAllowed = Math.max(...ranges.map((r) => r.max));

    if (age < minAllowed) {
        return {
            type: "too_young",
            message: `This program is designed for ages ${minAllowed}–${maxAllowed}. You entered an age of ${age}, which is below the eligible range.`,
        };
    }

    if (age > maxAllowed) {
        return {
            type: "too_old",
            message: `This program is designed for ages ${minAllowed}–${maxAllowed}. You entered an age of ${age}, which is above the eligible range.`,
        };
    }

    // age falls within the outer bounds but doesn't match any specific stage's gap
    return {
        type: "stage_mismatch",
        message: `Your age (${age}) doesn't align with the specific life stages this program covers (${lifeStages.map((l) => l.name).join(", ")}).`,
    };
};
const ProgramEnrollment = ({ program, isOpen, onClose, onComplete }) => {
    const [step, setStep] = useState(STEPS.DETAILS);
    const [consentChecked, setConsentChecked] = useState(false);
    const [ineligibleReason, setIneligibleReason] = useState(null);
    // form state
    const [fullName, setFullName] = useState("");
    const [dob, setDob] = useState("");
    const [mobile, setMobile] = useState("");
    const [nameErr, setNameErr] = useState("");
    const [dobErr, setDobErr] = useState("");
    const [mobErr, setMobErr] = useState("");
    const [formLoading, setFormLoading] = useState(false);
    const [formApiErr, setFormApiErr] = useState("");

    // otp state
    const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(""));
    const [otpError, setOtpError] = useState("");
    const [otpLoading, setOtpLoading] = useState(false);
    const [resent, setResent] = useState(false);
    const [countdown, setCountdown] = useState(60);
    const inputRefs = useRef([]);

    const [notif, setNotif] = useState(null);
    const notify = useCallback((type, message) => setNotif({ type, message }), []);

    const { user } = useAuth();

    // prefill from user/localStorage
    useEffect(() => {
        const storedName = localStorage.getItem("userName");
        if (storedName) setFullName(storedName);
    }, []);
    useEffect(() => {
        if (user?.fullName) setFullName(user.fullName);
        if (user?.mobile) setMobile(user.mobile);
        if (user?.dob) setDob(user.dob);
    }, [user,isOpen]);

    // countdown timer for resend
    useEffect(() => {
        if (step !== STEPS.OTP || countdown <= 0) return;
        const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
        return () => clearTimeout(timer);
    }, [step, countdown]);

    const isVerified = isMobileVerified(mobile || user?.mobile || "");

    if (!isOpen || !program) return null;

    const {
        programName,
        description,
        durationValue,
        durationUnit,
        price,
        consultationModes = [],
        conditionFocuses = [],
        lifeStages = [],
    } = program;

    const mode = consultationModes.map((c) => c.name).filter(Boolean).join(", ") || "Hybrid";
    const durationLabel = durationValue ? `${durationValue} ${durationUnit ?? "days"}` : null;
    const highlights = [
        ...conditionFocuses.map((c) => c.name),

    ].filter(Boolean);
    //   ...lifeStages.map((l) => l.name),

    const resetAndClose = () => {
        setStep(STEPS.DETAILS);
        setIneligibleReason(null);
        setConsentChecked(false);
        setFullName("");
        setDob("");
        setMobile("");
        setNameErr("");
        setDobErr("");
        setMobErr("");
        setFormApiErr("");
        setOtp(Array(OTP_LENGTH).fill(""));
        setOtpError("");
        setCountdown(60);
        onClose();
    };

    /* ── STEP 3: submit details → validate → check eligibility → send OTP (or skip) ── */
    const handleSendOtp = async () => {
        let ok = true;
        if (!fullName.trim()) { setNameErr("Full name is required"); ok = false; } else setNameErr("");
        if (!dob) { setDobErr("Date of birth is required"); ok = false; } else setDobErr("");
        if (!/^\d{10}$/.test(mobile.trim())) { setMobErr("Enter a valid 10-digit mobile number"); ok = false; } else setMobErr("");
        if (!ok) return;

        // eligibility check based on DOB vs program's lifeStages
        const age = calculateAge(dob);
        const eligible = checkEligibility(age, lifeStages);
        if (!eligible) {
            setIneligibleReason(getIneligibilityReason(age, lifeStages));
            setStep(STEPS.NOT_ELIGIBLE);
            return;
        }
        const isPrefilled = Boolean(user?.fullName && user?.mobile && user?.dob);
 if (isPrefilled) {
    setStep(STEPS.SUCCESS);
    return;
  }

        // already-verified user — skip OTP entirely
        if (isVerified) {
            handleRegisterAfterVerification(true, null);
            return;
        }

        setFormLoading(true);
        setFormApiErr("");
        try {
            const res = await sendQuickOtp({
                fullName: fullName.trim(),
                mobileNumber: mobile.trim(),
            });
            if (res.success) {
                notify("success", "OTP sent successfully! Please verify to continue enrollment.");
                setStep(STEPS.OTP);
            } else {
                notify("error", res.message || "Failed to send OTP. Please try again.");
            }
        } catch (err) {
            setFormApiErr(err?.response?.data?.message || "Failed to send OTP. Please try again.");
        } finally {
            setFormLoading(false);
        }
    };

    /* ── register (used both for verified-skip and post-OTP paths) ── */
    const handleRegisterAfterVerification = async (skipOtp, code) => {
        try {
            const registerResponse = await quickRegister({
                fullName: fullName.trim(),
                mobileNumber: mobile.trim(),
                dob: dob.trim(),
                otp: code,
                orgName: "FemCare",
            });

            storePatientSession({
                ...registerResponse.data,
                fullName: fullName.trim(),
                mobile: mobile.trim(),
                dob: dob.trim(),
                isVerified: true,
            });

            setStep(STEPS.SUCCESS);
        } catch (err) {
            notify("error", err?.response?.data?.message || err?.message || "Registration failed. Please try again.");
        }
    };

    /* ── OTP box handlers (same pattern as BookAppointment) ── */
    const handleOtpChange = (index, value) => {
        if (!/^\d?$/.test(value)) return;
        const updated = [...otp];
        updated[index] = value;
        setOtp(updated);
        setOtpError("");
        if (value && index < OTP_LENGTH - 1) inputRefs.current[index + 1]?.focus();
    };

    const handleOtpKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, OTP_LENGTH).split("");
        const updated = [...otp];
        pasted.forEach((digit, i) => { updated[i] = digit; });
        setOtp(updated);
        inputRefs.current[Math.min(pasted.length, OTP_LENGTH - 1)]?.focus();
    };

    const handleVerify = async (e) => {
        e.preventDefault();
        if (otpLoading) return;
        const code = otp.join("");
        if (code.length < OTP_LENGTH) {
            setOtpError(`Please enter all ${OTP_LENGTH} digits`);
            return;
        }

        setOtpLoading(true);
        setOtpError("");
        try {
            const verifyResponse = await verifyOtp({
                fullName: fullName.trim(),
                mobileNumber: mobile.trim(),
                otp: code,
            });

            if (!verifyResponse?.success) {
                setOtpError(verifyResponse?.message || "Invalid OTP. Please try again.");
                return;
            }

            notify("success", "OTP verified successfully");
            await handleRegisterAfterVerification(false, code);
        } catch (err) {
            setOtpError(err?.response?.data?.message || err?.message || "Invalid OTP. Please try again.");
        } finally {
            setOtpLoading(false);
        }
    };

    const handleResend = async () => {
        if (countdown > 0) return;
        try {
            setOtp(Array(OTP_LENGTH).fill(""));
            setOtpError("");
            setResent(false);
            setCountdown(60);
            await sendQuickOtp({ mobile: mobile.trim() });
            setResent(true);
            setTimeout(() => setResent(false), 3000);
        } catch (err) {
            setOtpError(err?.response?.data?.message || "Failed to resend OTP");
        }
    };

    return (
        <>
            {notif && (
                <Notification type={notif.type} message={notif.message} onClose={() => setNotif(null)} />
            )}
            <div
                style={{
                    position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    zIndex: 1000, padding: 16,
                }}
                onClick={resetAndClose}
            >
                <div
                    style={{
                        background: "#fff", borderRadius: 20, width: "100%", maxWidth: 440,
                        maxHeight: "90vh", overflowY: "auto", padding: "24px 24px 20px", position: "relative",
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {step !== STEPS.SUCCESS && (
                        <button
                            onClick={resetAndClose}
                            style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", cursor: "pointer", fontSize: 20, color: "#999", lineHeight: 1 }}
                        >
                            ×
                        </button>
                    )}

                    {/* ── STEP 1: PROGRAM DETAILS ── */}
                    {step === STEPS.DETAILS && (
                        <>
                            <span style={{ fontSize: 11, fontWeight: 600, color: "#e91e8c", letterSpacing: 0.5 }}>
                                STEP 1 OF 4 — PROGRAM DETAILS
                            </span>
                            <h2 style={{ fontSize: 19, fontWeight: 700, color: "#1a1a2e", margin: "8px 0 6px" }}>
                                {programName}
                            </h2>
                            <p style={{ fontSize: 13, color: "#666", lineHeight: 1.5, margin: "0 0 18px" }}>
                                {description}
                            </p>

                            <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
                                {durationLabel && (
                                    <div style={{ flex: 1, background: "#f8f8fa", borderRadius: 12, padding: "10px 12px" }}>
                                        <div style={{ fontSize: 10, color: "#aaa", fontWeight: 500, marginBottom: 3 }}>Duration</div>
                                        <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a2e" }}>{durationLabel}</div>
                                    </div>
                                )}
                                {price != null && (
                                    <div style={{ flex: 1, background: "#f8f8fa", borderRadius: 12, padding: "10px 12px" }}>
                                        <div style={{ fontSize: 10, color: "#aaa", fontWeight: 500, marginBottom: 3 }}>Price</div>
                                        <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a2e" }}>
                                            ₹{price.toLocaleString("en-IN")}
                                        </div>
                                    </div>
                                )}
                                <div style={{ flex: 1, background: "#f8f8fa", borderRadius: 12, padding: "10px 12px" }}>
                                    <div style={{ fontSize: 10, color: "#aaa", fontWeight: 500, marginBottom: 3 }}>Mode</div>
                                    <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a2e" }}>{mode}</div>
                                </div>
                            </div>

                            {highlights.length > 0 && (
                                <div style={{ marginBottom: 22 }}>
                                    <div style={{ fontSize: 11, fontWeight: 700, color: "#555", marginBottom: 8 }}>
                                        This program covers
                                    </div>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                        {highlights.map((h) => (
                                            <span key={h} style={{ fontSize: 11, color: "#e91e8c", background: "#fce4ec", borderRadius: 20, padding: "4px 10px", fontWeight: 500 }}>
                                                {h}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div style={{ display: "flex", gap: 10 }}>
                                <button className="btn-transparent" style={{ flex: 1 }} onClick={resetAndClose}>Cancel</button>
                                <button className="btn-secondary" style={{ flex: 1 }} onClick={() => setStep(STEPS.CONSENT)}>Continue</button>
                            </div>
                        </>
                    )}

                    {/* ── STEP 2: CONSENT ── */}
                    {step === STEPS.CONSENT && (
                        <>
                            <span style={{ fontSize: 11, fontWeight: 600, color: "#e91e8c", letterSpacing: 0.5 }}>
                                STEP 2 OF 4 — CONSENT
                            </span>
                            <h2 style={{ fontSize: 19, fontWeight: 700, color: "#1a1a2e", margin: "8px 0 14px" }}>
                                Before we proceed
                            </h2>

                            <div style={{ background: "#f8f8fa", borderRadius: 12, padding: "14px 16px", fontSize: 12.5, color: "#555", lineHeight: 1.6, marginBottom: 18, maxHeight: 200, overflowY: "auto" }}>
                                By continuing, you consent to sharing your personal and health-related
                                information (name, date of birth, and contact number) with our care team
                                for the purpose of enrolling you in the <strong>{programName}</strong>.
                                This information will be used to verify your eligibility, contact you
                                regarding your enrollment, and coordinate your care.
                            </div>

                            <label style={{ display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 22, cursor: "pointer", fontSize: 13, color: "#333" }}>
                                <input type="checkbox" checked={consentChecked} onChange={(e) => setConsentChecked(e.target.checked)} style={{ marginTop: 2 }} />
                                I have read and agree to share my information for this enrollment.
                            </label>

                            <div style={{ display: "flex", gap: 10 }}>
                                <button className="btn-transparent" style={{ flex: 1 }} onClick={() => setStep(STEPS.DETAILS)}>Back</button>
                                <button
                                    className="btn-secondary"
                                    style={{ flex: 1, opacity: consentChecked ? 1 : 0.5, pointerEvents: consentChecked ? "auto" : "none" }}
                                    onClick={() => setStep(STEPS.FORM)}
                                >
                                    Continue
                                </button>
                            </div>
                        </>
                    )}

                    {/* ── STEP 3: FORM ── */}
                    {step === STEPS.FORM && (
                        <>
                            <span style={{ fontSize: 11, fontWeight: 600, color: "#e91e8c", letterSpacing: 0.5 }}>
                                STEP 3 OF 4 — YOUR DETAILS
                            </span>
                            <h2 style={{ fontSize: 19, fontWeight: 700, color: "#1a1a2e", margin: "8px 0 18px" }}>
                                Tell us about you
                            </h2>

                            <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 22 }}>
                                <div>
                                    <label style={{ fontSize: 12, fontWeight: 600, color: "#444", display: "block", marginBottom: 5 }}>Full Name</label>
                                    <input
                                        type="text"
                                        value={fullName}
                                        onChange={(e) => { setFullName(e.target.value); setNameErr(""); }}
                                        placeholder="Enter your full name"
                                        style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: `1px solid ${nameErr ? "#e53935" : "#e0e0e0"}`, fontSize: 13, boxSizing: "border-box" }}
                                    />
                                    {nameErr && <span style={{ fontSize: 11, color: "#e53935" }}>{nameErr}</span>}
                                </div>

                                <div>
                                    <label style={{ fontSize: 12, fontWeight: 600, color: "#444", display: "block", marginBottom: 5 }}>Date of Birth</label>
                                    <input
                                        type="date"
                                        value={dob}
                                        min="1947-01-01"
                                        max={new Date().toISOString().split("T")[0]}
                                        onChange={(e) => { setDob(e.target.value); setDobErr(""); }}
                                        style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: `1px solid ${dobErr ? "#e53935" : "#e0e0e0"}`, fontSize: 13, boxSizing: "border-box" }}
                                    />
                                    {dobErr && <span style={{ fontSize: 11, color: "#e53935" }}>{dobErr}</span>}
                                </div>

                                <div>
                                    <label style={{ fontSize: 12, fontWeight: 600, color: "#444", display: "block", marginBottom: 5 }}>Mobile Number</label>
                                    <div style={{ display: "flex", borderRadius: 10, overflow: "hidden", border: `1px solid ${mobErr ? "#e53935" : "#e0e0e0"}` }}>
                                        <span style={{ display: "flex", alignItems: "center", padding: "0 12px", fontSize: 13, color: "#666", background: "#f8f8fa", borderRight: "1px solid #e0e0e0" }}>
                                            +91
                                        </span>
                                        <input
                                            type="tel"
                                            value={mobile}
                                            maxLength={10}
                                            disabled={isVerified}
                                            onChange={(e) => { if (!isVerified) { setMobile(e.target.value.replace(/\D/g, "")); setMobErr(""); } }}
                                            placeholder="Enter your number"
                                            style={{ flex: 1, padding: "10px 12px", border: "none", fontSize: 13, boxSizing: "border-box", background: isVerified ? "#f3f4f6" : "#fff", color: isVerified ? "#6b7280" : "inherit" }}
                                        />
                                    </div>
                                    {mobErr && <span style={{ fontSize: 11, color: "#e53935" }}>{mobErr}</span>}
                                    <p style={{ fontSize: 11, color: "#999", marginTop: 4 }}>
                                        {isVerified ? "Your mobile number is already verified." : "An OTP will be sent to this number for verification."}
                                    </p>
                                    {formApiErr && <p style={{ fontSize: 11, color: "#e53935", marginTop: 4 }}>{formApiErr}</p>}
                                </div>
                            </div>

                            <div style={{ display: "flex", gap: 10 }}>
                                <button className="btn-transparent" style={{ flex: 1 }} onClick={() => setStep(STEPS.CONSENT)}>Back</button>
                                <button
                                    className="btn-secondary"
                                    style={{ flex: 1, opacity: formLoading ? 0.7 : 1, cursor: formLoading ? "wait" : "pointer" }}
                                    onClick={handleSendOtp}
                                    disabled={formLoading}
                                >
                                    {formLoading ? "Sending OTP…" : isVerified ? "Continue" : "Send OTP"}
                                </button>
                            </div>
                        </>
                    )}

                    {/* ── NOT ELIGIBLE ── */}
                    {/* {step === STEPS.NOT_ELIGIBLE && (
            <>
              <div style={{ textAlign: "center", padding: "20px 0" }}>
                <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#fdecea", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}>
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#e53935" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" />
                  </svg>
                </div>
                <h2 style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", margin: "0 0 8px" }}>
                  Not Eligible for This Program
                </h2>
                <p style={{ fontSize: 13, color: "#777", lineHeight: 1.5, margin: "0 0 22px" }}>
                  Based on the details you've shared, this program may not be the right
                  fit for you right now. Our care team can help you find a more suitable option.
                </p>
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <button className="btn-transparent" style={{ flex: 1 }} onClick={() => setStep(STEPS.FORM)}>Back</button>
                <button className="btn-secondary" style={{ flex: 1 }} onClick={resetAndClose}>Close</button>
              </div>
            </>
          )} */}
                    {step === STEPS.NOT_ELIGIBLE && (
                        <>
                            <div style={{ textAlign: "center", padding: "20px 0" }}>
                                <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#fdecea", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}>
                                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#e53935" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" />
                                    </svg>
                                </div>
                                <h2 style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", margin: "0 0 8px" }}>
                                    Not Eligible for This Program
                                </h2>
                                <p style={{ fontSize: 13, color: "#777", lineHeight: 1.5, margin: "0 0 22px" }}>
                                    {ineligibleReason?.message ??
                                        "Based on the details you've shared, this program may not be the right fit for you right now."}
                                </p>
                            </div>
                            <div style={{ display: "flex", gap: 10 }}>
                                <button className="btn-transparent" style={{ flex: 1 }} onClick={() => setStep(STEPS.FORM)}>Back</button>
                                <button className="btn-secondary" style={{ flex: 1 }} onClick={resetAndClose}>Close</button>
                            </div>
                        </>
                    )}

                    {/* ── STEP 4: OTP (multi-box, matches BookAppointment) ── */}
                    {step === STEPS.OTP && (
                        <form onSubmit={handleVerify}>
                            <span style={{ fontSize: 11, fontWeight: 600, color: "#e91e8c", letterSpacing: 0.5 }}>
                                STEP 4 OF 4 — VERIFY MOBILE NUMBER
                            </span>
                            <h2 style={{ fontSize: 19, fontWeight: 700, color: "#1a1a2e", margin: "8px 0 6px" }}>
                                Enter Verification Code
                            </h2>
                            <p style={{ fontSize: 13, color: "#666", margin: "0 0 20px" }}>
                                We sent a {OTP_LENGTH}-digit OTP to <strong>+91 {mobile}</strong>
                            </p>

                            <div style={{ display: "flex", gap: 8, justifyContent: "center", marginBottom: 12 }} onPaste={handleOtpPaste}>
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        ref={(el) => (inputRefs.current[index] = el)}
                                        type="tel"
                                        inputMode="numeric"
                                        maxLength={1}
                                        value={digit}
                                        onChange={(e) => handleOtpChange(index, e.target.value)}
                                        onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                        style={{
                                            width: 44, height: 52, textAlign: "center", fontSize: 18, fontWeight: 700,
                                            borderRadius: 10, outline: "none",
                                            border: digit ? "2px solid #e91e8c" : otpError ? "2px solid #e53935" : "2px solid #e0e0e0",
                                            background: digit ? "#fce4ec" : "#fff", color: "#1a1a2e",
                                        }}
                                    />
                                ))}
                            </div>

                            {otpError && <p style={{ fontSize: 12, color: "#e53935", textAlign: "center", marginBottom: 10 }}>{otpError}</p>}
                            {resent && <p style={{ fontSize: 12, color: "#43a047", textAlign: "center", marginBottom: 10 }}>OTP resent successfully!</p>}

                            <p style={{ fontSize: 12, color: "#999", textAlign: "center", marginBottom: 18 }}>
                                Didn't receive it?{" "}
                                {countdown > 0 ? (
                                    <span style={{ color: "#bbb" }}>Resend in <strong style={{ color: "#e91e8c" }}>{countdown}s</strong></span>
                                ) : (
                                    <button type="button" onClick={handleResend} style={{ color: "#e91e8c", background: "none", border: "none", cursor: "pointer", fontWeight: 600 }}>
                                        Resend OTP
                                    </button>
                                )}
                            </p>

                            <div style={{ display: "flex", gap: 10 }}>
                                <button type="button" className="btn-transparent" style={{ flex: 1 }} onClick={() => setStep(STEPS.FORM)}>Back</button>
                                <button
                                    type="submit"
                                    className="btn-secondary"
                                    style={{ flex: 1, opacity: otpLoading ? 0.7 : 1, cursor: otpLoading ? "wait" : "pointer" }}
                                    disabled={otpLoading}
                                >
                                    {otpLoading ? "Verifying…" : "Confirm & Continue"}
                                </button>
                            </div>
                        </form>
                    )}

                    {/* ── SUCCESS ── */}
                    {step === STEPS.SUCCESS && (
                        <div style={{ textAlign: "center", padding: "20px 0" }}>
                            <div style={{ width: 72, height: 72, borderRadius: "50%", background: "#e8f5e9", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}>
                                <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#43a047" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12" />
                                </svg>
                            </div>
                            <h2 style={{ fontSize: 20, fontWeight: 700, color: "#1a1a2e", margin: "0 0 8px" }}>
                                Enrollment Successful!
                            </h2>
                            <p style={{ fontSize: 13, color: "#777", lineHeight: 1.5, margin: "0 0 24px" }}>
                                Thank you for enrolling in the <strong>{programName}</strong>.
                                Our care team will contact you within 24 hours on your registered number.
                            </p>
                            <button
                                className="btn-secondary"
                                style={{ width: "100%" }}
                                onClick={() => {
                                    onComplete?.({ program, fullName, dob, mobile });
                                    resetAndClose();
                                }}
                            >
                                Done
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ProgramEnrollment;